import { combineReducers } from 'redux'

import currentQueue from './current-queue'
import queues from './site-queues'
import queuesPagination from './queuesPagination'

export default combineReducers({
  currentQueue: currentQueue,
  list: queues,
  pagination: queuesPagination,
})



// WEBPACK FOOTER //
// ./src/modules/queues/reducers/index.js